import React, { useCallback, useEffect, useState } from "react";
import { API } from "../../shared/api/Api";
import { selectUserInformations } from "../../features/authSlice";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import axios from "axios";
import { showToast } from "../../utils/utils";
import PaymentTable from "../../components/Tables/PaymentTable";

const DEBOUNCE_DELAY = 700;

const PaymentPage = () => {
  const [reFetchData, setReFetchData] = useState(false);
  const [payments, setPayments] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [loader, setLoader] = useState(true);
  const [orderBy, setOrderBy] = useState("created_at");
  const [orderDir, setOrderDir] = useState("DESC");

  const user = useSelector(selectUserInformations);
  const params = useParams();

  const fetchPayments = useCallback(async () => {
    try {
      const { data } = await axios.get(
        `${API.Payments.app_courses_payments_all}`,
        {
          params: {
            page: currentPage,
            search: debouncedSearch,
            orderBy: orderBy,
            orderDir: orderDir,
          },
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      if (data.status === 200 && data.errorCode === 0) {
        setPayments(data.data.items);
        setCurrentPage(data.data.current_page);
        setTotalPages(data.data.last_page);
      } else {
        showToast("Error", "Failed to fetch courses", "error");
      }
    } catch (error) {
      showToast(
        "Error",
        error.response?.data?.message || "An error occurred",
        "error"
      );
    }
  }, [currentPage, debouncedSearch, user.token, orderBy, orderDir]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search);
      setCurrentPage(1); // Reset to the first page on search change
    }, DEBOUNCE_DELAY);

    return () => clearTimeout(handler);
  }, [search]);

  const handleSort = (column, direction) => {
    setOrderBy(column);
    setOrderDir(direction);
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoader(true); // Show loader during fetching
      try {
        setPayments([]);
        await fetchPayments();
      } catch (error) {
        showToast("Error", error || "An error occurred", "error");
      } finally {
        setLoader(false);
        setReFetchData(false);
      }
    };
    fetchData();
  }, [fetchPayments, reFetchData]);

  return (
    <div className="min-h-screen p-2 sl:pt-0 sm:p-2 md:p-4 sl:p-6">
      <PaymentTable
        currentPage={currentPage}
        loader={loader}
        onPageChange={setCurrentPage}
        onSearchChange={setSearch}
        payments={payments}
        totalPages={totalPages}
        setReFetchData={setReFetchData}
        onSort={handleSort}
        currentOrderBy={orderBy}
        currentOrderDir={orderDir}
      />
    </div>
  );
};

export default PaymentPage;
